import {Button, Modal} from '@logistics-frontend/blocks'
import {Input, InputVariants} from '@logistics-frontend/blocks/legacy'
import {useI18n} from '@logistics-frontend/core/i18n'
import React, {useCallback, useState} from 'react'

import {classes} from './CommentDesktop.styles'

type Props = {
  comment?: string
  onSubmit: (newComment: string) => void
  onClose: VoidFunction
}

const DetailsDesktop: React.FC<Props> = ({comment = '', onClose, onSubmit}) => {
  const t = useI18n()
  const [newComment, setNewComment] = useState<string>(comment)
  const handleCommentChange: React.ChangeEventHandler<HTMLInputElement> = useCallback(
    event => {
      setNewComment(event.target.value)
    },
    [setNewComment],
  )
  const handleSubmitClick = useCallback(() => onSubmit(newComment), [newComment, onSubmit])

  return (
    <Modal className={classes.modalBody} data-e2e="modal-feedback-delivery" onClose={onClose} opened>
      <Modal.Title variant="title4">{t('route_feedback')}</Modal.Title>
        <Input
          className={classes.input}
          clearable={false}
          data-e2e="input-feedback-delivery"
          onChange={handleCommentChange}
          placeholder={t('route_feedback_comment')}
          value={newComment}
          variant={InputVariants.Line}
        />
      <Button className={classes.button} data-e2e="button-save" onPress={handleSubmitClick} variant="action" fullWidth>
        {t('route_feedback_done')}
      </Button>
    </Modal>
  )
}

export default DetailsDesktop
